import { FormattedMessage } from 'react-intl';

export const welcome = () => {
    return (
        <FormattedMessage
            id='kiosk.home.login.welcome'
            defaultMessage='Welcome to'
        />
    );
};
